import { KeyValue }           from '@angular/common';
import { FormuleProductEnum } from '@shared/constants/formule-product.enum';
import { ESTATE_FORMULE }     from '@shared/enums/ESTATE_FORMULE';
import { FormuleEnum }        from '@shared/enums/formule.enum';

export class DataTarificationPhaseB {
  id: FormuleEnum | FormuleProductEnum;
  check: ESTATE_FORMULE;
  mnts?: KeyValue<string, number>[];
  mnt: number;
  formuleSelected?: FormuleEnum;

  constructor () {
    this.mnt = 0;
  }
}
